<main class="h-full w-full">
  <ts-empty-state
    icon="ts_close"
    title="Page Not Found"
    subtitle="The requested page was not found. Click below to go back."
    [buttonConfig]="goBackButtonConfig"
  ></ts-empty-state>
</main>
